import { useLocation, useNavigate } from 'react-router';
import { redirectAfterSignIn } from './utils.ts';
import { styles } from '~/modules/auth/styles.ts';
import { Box, Typography, Grid, Button } from '@mui/material';
import { FormProvider } from 'react-hook-form';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import { errorMessagesSignIn } from '~/constants/errorMessages.ts';
import { useSingInForm } from '~/modules/auth/hooks/useHookForms.ts';
import { FormPassword } from '~/components/FormComponents/FormPassword.tsx';
import { loginManager } from '~/store/users/thunks.ts';
import { TLoginRequest } from '~/store/users/types.ts';
import { useAppDispatch } from '~/store/appDispatch.ts';
import FormGridItem from '~/components/FormComponents/FormGridItem';

interface ISignInManagerProps {
  redirectTo?: string;
}

export default function SignInManager({ redirectTo }: ISignInManagerProps) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const form = useSingInForm(true);
  const { isSubmitting } = form.formState;

  const locationRedirect = location.state?.from;
  const resolvedRedirect = redirectTo || locationRedirect;
  const isCovenantsRoute =
    typeof resolvedRedirect === 'string' &&
    (resolvedRedirect.startsWith('/covenants') || resolvedRedirect.startsWith('/covenant'));

  const onSubmit = async (values: TLoginRequest) => {
    try {
      const result = await dispatch(
        loginManager({ data: values, logoutPreviousSession: isCovenantsRoute })
      ).unwrap();

      redirectAfterSignIn({
        groups: result.groups,
        resolvedRedirect,
        dispatch,
        navigate,
      });
    } catch {
      form.setError('password', { message: errorMessagesSignIn.LOGIN_FAILED });
    }
  };

  return (
    <Box sx={styles.container}>
      <Box sx={styles.containerSignManager}>
        <Typography sx={styles.headerText}>Вхід</Typography>
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <Grid>
              <FormGridItem>
                <FormInput
                  name="username"
                  label="Логін"
                  placeholder="Введіть системний логін"
                  fullWidth
                />
              </FormGridItem>
              <FormGridItem>
                <FormPassword
                  type="password"
                  autoComplete="current-password"
                  name="password"
                  label="Пароль"
                  placeholder={'Введіть системний пароль'}
                  fullWidth
                />
              </FormGridItem>
            </Grid>
            <Box style={{ display: 'flex', justifyContent: 'center' }}>
              <Button type="submit" variant={'contained'} disabled={isSubmitting}>
                Увійти
              </Button>
            </Box>
          </form>
        </FormProvider>
      </Box>
    </Box>
  );
}
